module.exports = __webpack_public_path__ + "static/media/day-cloud-rain-icon.0d9dfddc.svg";